/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  SubmittedAppService,
  ISubmittedAppMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  FormatAppService,
  IFormatAppMethods,
  GetWPApplicationService,
  IGetWPApplicationMethods,
  IRenewWorkPermitMethods,
  RenewWorkPermitService,
  ITerminateWorkPermitMethods,
  TerminateWorkPermitService,
  IAppealApplicationMethods,
  AppealApplicationService,
  IRenewCSMECertificateMethods,
  RenewCSMECertificateService,
  IrenewMarriageExemptionMethods,
  renewMarriageExemptionService,
  IGetCertificateMethods,
  GetCertificateService,
  IRejectedDocumentsApplicationMethods,
  RejectedDocumentsApplicationService,
  rejectedDocsApplicantService,
  IrejectedDocsApplicantMethods,
  GetPdfService,
  IGetPdfMethods
} from './plugins';

export type ApplicationDetailPageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  ISubmittedAppMethods &
  IFormatAppMethods &
  IGetWPApplicationMethods &
  IRenewWorkPermitMethods &
  IrenewMarriageExemptionMethods &
  ITerminateWorkPermitMethods &
  IAppealApplicationMethods &
  IRenewCSMECertificateMethods &
  IGetCertificateMethods &
  IRejectedDocumentsApplicationMethods &
  IrejectedDocsApplicantMethods &
  IGetPdfMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SubmittedAppService(),
    new FormatAppService(),
    new GetWPApplicationService(),
    new RenewWorkPermitService(),
    new renewMarriageExemptionService(),
    new TerminateWorkPermitService(),
    new AppealApplicationService(),
    new RenewCSMECertificateService(),
    new GetCertificateService(),
    new RejectedDocumentsApplicationService(),
    new rejectedDocsApplicantService(),
    new GetPdfService()
  ];
};

export const getAgent = () => {
  return createAgent<ApplicationDetailPageAgent>({
    plugins: getPlugins(),
  });
};
